import { Mail, Phone, MapPin } from "lucide-react";
import { Seo } from "@/components/Seo";
import { PageIntro } from "@/components/PageIntro";
import { Reveal } from "@/components/Motion";
import { EnquiryForm } from "@/components/EnquiryForm";
import { COMPANY } from "@/data/site";

const Detail = ({ icon: Icon, label, children }) => (
  <div className="flex gap-4 border-t border-white/15 py-6">
    <Icon className="mt-1 h-5 w-5 shrink-0 text-lime" aria-hidden="true" />
    <div>
      <p className="eyebrow text-white/70">{label}</p>
      <div className="mt-2 text-lg text-white">{children}</div>
    </div>
  </div>
);

export default function Contact() {
  return (
    <>
      <Seo
        title="Contact PRPO LTD — Start a Design Project"
        description="Get in touch with PRPO LTD about graphic design, branding, logo, packaging, brochure, website or UI design projects. Email, phone or send a project enquiry."
        path="/contact"
      />
      <PageIntro
        testid="contact-intro"
        label="Contact"
        lines={[{ content: "Let’s Create Something" }, { content: "Exceptional.", className: "text-royal" }]}
        text="Have a project in mind? Tell us about your business, your goals, and the design support you need. We’d love to hear from you."
      />
      <section className="pb-24 sm:pb-36" aria-label="Contact details and enquiry form">
        <div className="shell grid gap-12 lg:grid-cols-12 lg:gap-16">
          <Reveal className="lg:col-span-4">
            <aside className="on-dark rounded-lg bg-navy p-7 text-white sm:p-10 lg:sticky lg:top-28" data-testid="contact-details">
              <h2 className="font-display text-2xl font-bold tracking-tight">Contact details</h2>
              <div className="mt-8">
                <Detail icon={Mail} label="Email">
                  <a href={`mailto:${COMPANY.email}`} className="break-all underline decoration-lime/60 underline-offset-4 hover:text-lime" data-testid="contact-email-link">{COMPANY.email}</a>
                </Detail>
                <Detail icon={Phone} label="Phone">
                  <a href={COMPANY.phoneHref} className="underline decoration-lime/60 underline-offset-4 hover:text-lime" data-testid="contact-phone-link">{COMPANY.phone}</a>
                </Detail>
                <Detail icon={MapPin} label="Business address">
                  <address className="not-italic leading-relaxed" data-testid="contact-address">
                    {COMPANY.addressLines.map((l, i) => <span key={l} className="block">{l}{i < COMPANY.addressLines.length - 1 ? "," : "."}</span>)}
                  </address>
                </Detail>
              </div>
            </aside>
          </Reveal>
          <Reveal delay={0.1} className="lg:col-span-8">
            <h2 className="mb-10 font-display text-3xl font-bold tracking-tight text-navy sm:text-4xl">Project enquiry</h2>
            <EnquiryForm />
          </Reveal>
        </div>
      </section>
    </>
  );
}
